const COLORS = ["#15715B", "#EECD42", "#B4DEF2", "#A52331"];

export default COLORS;
